import { render, staticRenderFns } from "./SkillCourt.vue?vue&type=template&id=23352822&scoped=true&"
import script from "./SkillCourt.vue?vue&type=script&lang=js&"
export * from "./SkillCourt.vue?vue&type=script&lang=js&"
import style0 from "./SkillCourt.vue?vue&type=style&index=0&id=23352822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23352822",
  null
  
)

export default component.exports